import { ADMIN_ROLES, type Role } from "@/api/permissions";
import { authClient } from "./auth-client";

/**
 * Local-dev role simulation.
 *
 * The backend's NODE_ENV=local bypass grants superadmin to every request,
 * which makes the role-gated UI (nav items, the marketing-safe metrics
 * subset, KPI tiles) untestable without a real Entra login. The header below
 * tells that bypass which role to attach instead — see
 * `readLocalRoleOverride` in `../../../src/middleware/admin-auth.ts`.
 *
 * It is only ever sent when `authClient.mode === "local"`, and the backend
 * only ever reads it under NODE_ENV=local, so it is inert in every deployed
 * environment.
 */
const STORAGE_KEY = "moreta.admin.localRole";
const DEFAULT_LOCAL_ROLE: Role = "superadmin";

export const LOCAL_ROLE_HEADER = "x-admin-role-override";

export const isLocalRoleSwitchingEnabled = (): boolean =>
  authClient.mode === "local";

export const getLocalRole = (): Role => {
  if (!isLocalRoleSwitchingEnabled()) return DEFAULT_LOCAL_ROLE;
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored !== null && (ADMIN_ROLES as readonly string[]).includes(stored)
    ? (stored as Role)
    : DEFAULT_LOCAL_ROLE;
};

export const setLocalRole = (role: Role): void => {
  localStorage.setItem(STORAGE_KEY, role);
};
